import { Logo, Radiounselected,overlayStyle, loaderStyle, } from '../../common/common'
import MidChooseCountry from '../../middleware/Authentication/MidChooseCountry';
import useNavigation from '../../common/useNavigation.js';

const ChooseCountry = () => {

    const { navigateLogin, navigatePrivacyPolicy } = useNavigation();
    const { signupCountry, changeCountry, currentValue,isLoading } = MidChooseCountry();
    return (
        <div className="bg-white w-full h-screen overflow-y-auto overflow-x-hidden">
            <div className=' text-center justify-center flex'>
                <img src={Logo} width={220} height={70} alt='Logo' />
            </div>
            <div className=" max-w-[360px] w-full bg-white my-0 mx-auto p-7 " style={{ boxShadow: 'rgb(0 0 0 / 10%) 0px 0px 10px' }}>
                <form className="form">
                    <h1 className="font-bold text-[#121A30] text-center  text-2xl">Get started</h1>
                    <p className=" text-gray-500 text-center mt-2 text-md"> Free Up to 2 user  </p>
                    <center>
                        <h1 className=" my-2"> Please Select Your Country</h1>
                    </center>
                    <div className="flex flex-row justify-between my-5">
                        {signupCountry.map((country, id) => {
                            return (
                                <div key={id} className={`${currentValue === country.id ? "border-[] border-solid border-[#e5e5e5]" : "border-[1px] border-solid border-[#e5e5e5]"} flex flex-col h-40 w-60 border-[1px]  p-2 rounded-xl opacity-90 hover:opacity-100  shadow-lg shadow-[#e5e5e5] mx-2 cursor-pointer hover:shadow-xl`} onClick={() => changeCountry(country)}>
                                    <div className="w-full flex flex-row justify-end">
                                        {currentValue === country.id ? (<img className="" src={Radiounselected} width={12} height={12} alt="radioindia" />) : (<img className="" src={Radiounselected} width={12} height={12} alt="radiointernational" />)}
                                    </div>
                                    <img className="m-auto" src={country.countrymap} width={`${country.id === 2 ? "180" : "80"}`} alt="countrymap" />
                                    <h1 className="text-center font-bold text-md text-[#121A30]" > {" "} {country.name}{" "} </h1>
                                </div>
                            );
                        })}
                    </div>
                    <div className="text-center py-2 text-xs ">
                        <p> By clicking below, you agree to the Selzor{" "}
                            <a href="#" target="_blank" > Cloud Terms of Service </a>{" "} and{" "}
                            <a href="#" target="_blank" > Privacy Policy </a> .
                        </p>
                    </div>
                </form>
                <div className="my-2 border-b-[1px] border-solid border-[#e5e5e5] h-1"></div>
                <div className="text-center  mx-0 font-semibold ">
                    <p className="py-2 text-sm "> {" "} Already Have an Account?{" "}
                        <span className="text-blue-500 cursor-pointer" onClick={navigateLogin} > {" "} Login Now </span>
                    </p>
                </div>
                <div className=" mx-0 text-center mt-2 text-xs text-[#777575] ">
                    <p className=" font-sm font-semibold"> This site is protected by reCAPTCHA and the{" "}
                        <span className="text-xs text-blue-500 cursor-pointer" onClick={navigatePrivacyPolicy} > {" "} Google Privacy Policy{" "} </span>{" "} and{" "}
                        <span className="text-xs text-blue-500 cursor-pointer" onClick={() => { }} > Terms of Service apply. </span>
                    </p>
                </div>
            </div>
            <footer className='max-w-[1200px]  text-center mt-16 mx-auto  '>
                
                <div className='  grid grid-cols-2 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-7 xl:grid-cols-7 space-x-2 my-2'>
                    <div > <a href="#">Features</a></div>
                    <div > <a href="#">Price </a></div>
                    <div > <a href="#">Application </a></div>
                    <div > <a href="#">Blogs </a></div>
                    <div > <a href="#">About </a></div>
                    <div > <a href="#">Help </a></div>
                    <div > <a href="#">Documentation </a></div>
                </div>
                <p className=' text-slate-400 '>&copy; Copyright. All rights Reserved {(new Date().getFullYear())} </p>
            </footer>
            {isLoading && (
                            <div style={overlayStyle}>
                                <div style={loaderStyle}>Loading...</div>
                            </div>
                        )}
        </div>
        
    )
}

export default ChooseCountry